// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"703def8a","455":"452f5c17","977":"fc741ab6"}[chunkId] + ".chunk.js";
};